'use client'

import { useEffect } from 'react'
import Intercom from '@intercom/messenger-js-sdk'

interface IntercomProviderProps {
  userId?: string | null
  name?: string | null
  email?: string | null
  createdAt?: number | null
  hideLauncher?: boolean
}

const APP_ID = 'vuxy5d7q'

export function IntercomProvider({ userId, name, email, createdAt, hideLauncher = true }: IntercomProviderProps) {
  useEffect(() => {
    Intercom({
      app_id: APP_ID,
      hide_default_launcher: hideLauncher,
      ...(userId ? { user_id: userId } : {}),
      ...(name ? { name } : {}),
      ...(email ? { email } : {}),
      ...(createdAt ? { created_at: createdAt } : {}),
    })
  }, [userId, name, email, createdAt])

  return null
}

export function openIntercom() {
  if (typeof window !== 'undefined' && typeof (window as Window & { Intercom?: (cmd: string) => void }).Intercom === 'function') {
    ;(window as unknown as { Intercom: (cmd: string) => void }).Intercom('show')
  }
}
